import { useMediaQuery, useTheme } from '@mui/material'
import { Box } from '@mui/system'
import { useSelector } from 'react-redux'
import { environment } from '../../../enviroments/enviroment'
import { getCurrentMode } from '../../../store/redux/reducers/darkModeSlice'

const logoLight = `${environment.publicUrl}/assets/image/bee2code_logo_black.svg`
const logoDark = `${environment.publicUrl}/assets/image/bee2code_logo_white.svg`
const logoIcon = `${environment.publicUrl}/assets/image/bee2code_logo_icon.svg`

const SystemNotificationCardLogo = () => {
  const mode = useSelector(getCurrentMode)
  const theme = useTheme()
  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box
      alt={'Logo, Beecrew'}
      component={'img'}
      src={isDownSm ? logoIcon : mode === 'light' ? logoLight : logoDark}
      sx={{
        ml: '-8px',
        width: isDownSm ? 64 : 84,
        height: 32,
      }}
    />
  )
}

export default SystemNotificationCardLogo
